import React, { Component } from "react";
import Card from "@material-ui/core/Card";
import userdefault from "../../../assets/images/userdefault.svg";
import "./addCollateral.scss";
import Input from "@material-ui/core/Input";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import Sidebar from "../../sidebar/sidebar";
import { BaseUrl, ImageBaseUrl } from "../../../Environment";
import { toast } from "react-toastify";
import { withNamespaces } from "react-i18next";
import { getSecureItem } from "../../../utilsFunctions";
import Axios from "axios";

const COLLATERAL_FIELDS = {
  Automobiles: [
    { name: "vehicleEngineNumber", label: "Engine Number", required: false },
    { name: "chassisNumber", label: "Chassis Number", required: false },
    { name: "vehicleModel", label: "Model", required: true },
    { name: "vehicleMake", label: "Make", required: true },
    { name: "vehicleNumber", label: "Registration Number", required: true },
    { name: "mileage", label: "Mileage", required: true },
    { name: "colour", label: "Colour", required: false },
  ],

  "Electronic Items": [
    { name: "make", label: "Make", required: true },
    { name: "model", label: "Model", required: true },
    { name: "condition", label: "Condition", required: false },
  ],

  "Insurance Policies": [
    { name: "policyNumber", label: "Policy Number", required: true },
    {
      name: "registerDate",
      label: "Register Date",
      required: false,
      type: "date",
    },
    {
      name: "maturityDate",
      label: "Maturity Date",
      required: true,
      type: "date",
    },
  ],

  Investments: [
    { name: "depositReceiptNumber", label: "Receipt Number", required: true },
    {
      name: "registerDate",
      label: "Register Date",
      required: false,
      type: "date",
    },
    {
      name: "maturityDate",
      label: "Maturity Date",
      required: true,
      type: "date",
    },
  ],

  "Machinery and Equipment": [
    { name: "make", label: "Make", required: true },
    { name: "model", label: "Model", required: true },
    { name: "age", label: "Age", required: false },
    { name: "condition", label: "Condition", required: false },
  ],

  "Valuables and Collectibles": [
    { name: "gram", label: "Gram", required: true },
    { name: "valuableType", label: "Valuable Type", required: true },
    { name: "purity", label: "Purity", required: false },
  ],

  "Real Estate": [
    { name: "propertyLocation", label: "Property Location", required: true },
    { name: "surveyNumber", label: "Survey Number", required: true },
    {
      name: "propertyDescription",
      label: "Property Description",
      required: false,
    },
  ],
};

class AddCollateral extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customersData: [],
      loansData: [],
      selectedCustomer: null,
      selectedLoan: null,
      type: "",
      value: "",
      serialNumber: "",
      registerDate: "",
      imagePreviewUrl: "",
      file: null,
      collateralId: null,
      borderStyles: {},
      selectedCustomer: null,
      chooseBorrower: "",
      allCustomer: [],
      showCustomerDropdown: false,
      searchdoneCustomer: false,
    };
    this.customerWrapperRef = React.createRef();
  }

  searchList = (e) => {
    const loggedinUser = getSecureItem("loggedinUserCompany");
    const value = e.target.value;

    this.setState({
      chooseBorrower: value,
      showCustomerDropdown: true,
      selectedCustomer: null,
      selectedLoan: null,
    });

    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + getSecureItem("token"),
    };

    Axios.get(
      `${BaseUrl}/customer/getVerifiedCustomers?name=${value}&companyId=${loggedinUser}`,
      { headers }
    ).then((resp) => {
      if (resp.status === 200) {
        this.setState({ allCustomer: resp.data });
        if (resp.data.length <= 0) {
          this.setState({ chooseBorrower: "" });
        }
      } else {
        toast.error("Please try again!");
      }
    });
  };

  selectName = (selectedData) => {
    this.setState({
      chooseBorrower: selectedData.cust_id
        ? `${selectedData.firstName} ${selectedData.lastName} (${selectedData.cust_id})`
        : `${selectedData.firstName} ${selectedData.lastName}`,
      selectedCustomer: { label: `${selectedData.firstName} ${selectedData.lastName}`, value: selectedData.customerId },
      showCustomerDropdown: false,
      searchdoneCustomer: false,
      selectedLoan: null,
    });
    this.getAllLoans(selectedData.customerId);
  };

  renderCustomerDropdown = () => {
    const { allCustomer, showCustomerDropdown, searchdoneCustomer } = this.state;
    return allCustomer.length > 0 && showCustomerDropdown ? (
      <div
        style={{
          position: "absolute",
          top: "45px",
          left: 0,
          border: "1px solid lightgrey",
          borderRadius: "5px",
          width: "100%",
          maxHeight: "250px",
          overflowY: "auto",
          background: "#fff",
          zIndex: 10,
        }}
      >
        {allCustomer.map((option) => (
          <option
            key={option.customerId}
            value={option.firstName}
            className="Fonts"
            style={{ padding: "8px", cursor: "pointer" }}
            onClick={() => this.selectName(option)}
          >
            {option.cust_id
              ? `${option.firstName} ${option.lastName} (${option.cust_id})`
              : `${option.firstName} ${option.lastName}`}
          </option>
        ))}
      </div>
    ) : (
      searchdoneCustomer && (
        <div className="errorMsg">Choose a valid customer</div>
      )
    );
  };

  async componentDidMount() {
    const collateral = this.props.location?.state?.collateral;

    this.initBorderStyles();

    await this.getAllCustomers();

    if (collateral) {
      const matchedCustomer = this.state.customersData.find(
        (c) => c.value === collateral.customerId,
      );

      this.setState({
        collateralId: collateral.collateralId,

        selectedCustomer: matchedCustomer || {
          label: `${collateral.customer?.firstName} ${collateral.customer?.lastName}`,
          value: collateral.customerId
        },

        chooseBorrower: collateral.customer?.cust_id
          ? `${collateral.customer?.firstName} ${collateral.customer?.lastName} (${collateral.customer?.cust_id || ""})`
          : `${collateral.customer?.firstName} ${collateral.customer?.lastName}`,

        type: collateral.type,
        value: collateral.value,
        serialNumber: collateral.serialNumber,
        registerDate: collateral.registerDate,
        imagePreviewUrl: collateral.proofs?.length
          ? ImageBaseUrl + "/" + collateral.proofs[0].proofImagePath
          : "",
        ...collateral.detailsJson,
      });

      await this.getAllLoans(collateral.customerId);

      const matchedLoan = this.state.loansData.find(
        (l) => l.value === collateral.loanId,
      );

      this.setState({
        selectedLoan: matchedLoan || {
          label: collateral.loanId,
          value: collateral.loanId
        },
      });
    }
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onloadend = () => {
      this.setState({
        file: file,
        imagePreviewUrl: reader.result,
      });
    };

    reader.readAsDataURL(file);
  };

  handleClickOutside = (event) => {
    if (this.customerWrapperRef?.current && !this.customerWrapperRef.current.contains(event.target)) {
      this.setState({ showCustomerDropdown: false });
    }
  };

  initBorderStyles = () => {
    let borders = {};
    Object.keys(COLLATERAL_FIELDS).forEach((category) => {
      COLLATERAL_FIELDS[category].forEach((f) => {
        borders[f.name] = "1px solid #D4D4D5";
      });
    });
    borders.customer =
      borders.loan =
      borders.type =
      borders.value =
      borders.serialNumber =
      "1px solid #D4D4D5";
    this.setState({ borderStyles: borders });
  };

  setBorder = (field) => {
    let reset = {};
    Object.keys(this.state.borderStyles).forEach((k) => {
      reset[k] = "1px solid #D4D4D5";
    });
    this.setState({ borderStyles: { ...reset, [field]: "1px solid #00D95E" } });
  };

  isRequired = (fieldName) => {
    const { type } = this.state;
    return COLLATERAL_FIELDS[type]?.some(
      (f) => f.name === fieldName && f.required,
    );
  };

  isFieldVisible = (fieldName) => {
    const { type } = this.state;
    return COLLATERAL_FIELDS[type]?.some((f) => f.name === fieldName);
  };

  renderField = (field) => {
    if (!this.isFieldVisible(field.name)) return null;

    const fieldType = field.type || "text";

    return (
      <div className="textFieldStyle width50100" key={field.name}>
        <h6 className="InputLabel Fonts SizeFont">
          {field.label}
          {field.required && <span style={{ color: "red" }}> *</span>}
        </h6>

        <Input
          type={fieldType}
          placeholder={`Enter ${field.label}`}
          style={{ border: this.state.borderStyles[field.name] }}
          value={this.state[field.name] || ""}
          onClick={() => this.setBorder(field.name)}
          onChange={(e) => this.setState({ [field.name]: e.target.value })}
        />
      </div>
    );
  };

  getAllCustomers = async () => {
    const loggedinUser = getSecureItem("loggedinUser");
    const token = getSecureItem("token");
    const companyId = getSecureItem("loggedinUserCompany");

    try {
      const resp = await Axios.post(
        BaseUrl + "/customer/getAllCustomersMobile",
        {
          companyId,
          collectorId: loggedinUser?.userId,
          userType: loggedinUser?.userType,
          fullData: true,
        },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      const list = resp.data?.result?.map((item) => ({
        label: `${item.firstName} ${item.lastName} (${item.cust_id})`,
        value: item.customerId,
      }));

      this.setState({ customersData: list });
    } catch (err) { }
  };

  getAllLoans = async (customerId) => {
    const token = getSecureItem("token");
    const companyId = getSecureItem("loggedinUserCompany");

    try {
      const resp = await Axios.get(
        BaseUrl +
        `/loan/getLoansforCustomers?customerId=${customerId}&companyId=${companyId}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      const loanList = resp.data?.map((item) => ({
        label: item.loanId,
        value: item.loanId,
      }));

      this.setState({ loansData: loanList });
    } catch (err) { }
  };

  handleSubmit = async () => {
    const token = getSecureItem("token");
    const loggedinUser = getSecureItem("loggedinUser");

    const {
      selectedCustomer,
      selectedLoan,
      type,
      value,
      file,
      serialNumber,
      registerDate,
      collateralId,
    } = this.state;

    let borderStyles = { ...this.state.borderStyles };

    if (!selectedCustomer) {
      borderStyles.customer = "1px solid red";
    }
    if (!selectedLoan) {
      borderStyles.loan = "1px solid red";
    }
    if (!type) {
      borderStyles.type = "1px solid red";
    }

    let isError = false;

    const detailsJson = {};
    (COLLATERAL_FIELDS[type] || []).forEach((f) => {
      const value = this.state[f.name];

      detailsJson[f.name] = value || "";

      if (f.required && (!value || value.toString().trim() === "")) {
        borderStyles[f.name] = "1px solid red";
        isError = true;
      }
    });

    if (!selectedCustomer || !selectedLoan || !type || isError) {
      this.setState({ borderStyles });
      toast.error("Please fill all required fields.");
      return;
    }

    const payload = {
      collateralId: collateralId || undefined,
      companyId: loggedinUser.companyId,
      customerId: selectedCustomer.value,
      loanId: selectedLoan.value,
      registerDate,
      serialNumber,
      type,
      value,
      detailsJson,
      createdByUserId: loggedinUser.userId,
      updatedByUserId: loggedinUser.userId,
    };

    const formData = new FormData();
    formData.append("payload", JSON.stringify(payload));
    if (file) formData.append("collateralPhoto", file);

    const apiUrl = collateralId
      ? `${BaseUrl}/collateral/putCollateral`
      : `${BaseUrl}/collateral/postCollateral`;

    try {
      const resp = await Axios({
        method: collateralId ? "PUT" : "POST",
        url: apiUrl,
        data: formData,
        headers: { Authorization: `Bearer ${token}` },
      });

      if (resp.data.status) {
        toast.success(
          collateralId
            ? "Collateral updated successfully"
            : "Collateral added successfully",
        );
        this.props.history.push("/viewCollateral");
      } else {
        toast.error(resp.data.message || "Error saving collateral");
      }
    } catch (err) {
      toast.error("Server Error");
    }
  };

  render() {
    const { customersData, loansData, type } = this.state;

    return (
      <div>
        <Sidebar />

        <div style={{ textAlign: "center", marginTop: "15px" }}>
          <h3 className="Fonts headFontSize" style={{ marginLeft: "45px" }}>
            <span className="backLink">
              {this.state.collateralId
                ? "View / Update Collateral Info"
                : "Add Collateral Info"}
            </span>
          </h3>
        </div>

        <div className="addCollateralComponent">
          <Card className="cardDiv">
            <div className="previewComponent">
              <form onSubmit={(e) => e.preventDefault()}>
                <div className="flexRowColumn">
                  <div className="textFieldStyle width50100">
                    <h6 className="InputLabel Fonts SizeFont">
                      Customer <span style={{ color: "red" }}> *</span>
                    </h6>
                    <div
                      ref={this.customerWrapperRef}
                      style={{ position: "relative" }}
                    >
                      <Input
                        value={this.state.chooseBorrower || ""}
                        className="width50100"
                        style={{
                          height: "41px",
                          border: this.state.borderStyles.customer,
                        }}
                        placeholder="Search Customer"
                        onClick={() => this.setBorder("customer")}
                        onChange={this.searchList}
                        onBlur={() => this.setState({ searchdoneCustomer: true })}
                      />
                      {this.renderCustomerDropdown()}
                    </div>
                  </div>
                  <div className="textFieldStyle width50100">
                    <h6 className="InputLabel Fonts SizeFont">
                      Loan <span style={{ color: "red" }}> *</span>
                    </h6>
                    <Select
                      value={this.state.selectedLoan}
                      className="width50100"
                      style={{
                        height: "41px",
                        border: this.state.borderStyles.loan,
                      }}
                      disabled={!this.state.selectedCustomer}
                      onClick={() => this.setBorder("loan")}
                      onChange={(e) =>
                        this.setState({ selectedLoan: e.target.value })
                      }
                    >
                      {loansData.map((x, i) => (
                        <MenuItem key={i} value={x}>
                          {x.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                </div>
                <div className="flexRowColumn">
                  <div className="textFieldStyle width50100">
                    <h6 className="InputLabel Fonts SizeFont">
                      Collateral Type <span style={{ color: "red" }}> *</span>
                    </h6>
                    <Select
                      value={type}
                      className="width50100"
                      style={{
                        height: "41px",
                        border: this.state.borderStyles.type,
                      }}
                      onClick={() => this.setBorder("type")}
                      onChange={(e) => this.setState({ type: e.target.value })}
                    >
                      {Object.keys(COLLATERAL_FIELDS).map((t, index) => (
                        <MenuItem key={index} value={t}>
                          {t}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                  <div className="textFieldStyle width50100">
                    <h6 className="InputLabel Fonts SizeFont">Register Date</h6>
                    <Input
                      type="date"
                      style={{ border: this.state.borderStyles.registerDate }}
                      value={this.state.registerDate}
                      onClick={() => this.setBorder("registerDate")}
                      onChange={(e) =>
                        this.setState({ registerDate: e.target.value })
                      }
                    />
                  </div>
                </div>
                <div className="flexRowColumn">
                  <div className="textFieldStyle width50100">
                    <h6 className="InputLabel Fonts SizeFont">Serial Number</h6>
                    <Input
                      placeholder="Enter Serial Number"
                      value={this.state.serialNumber}
                      style={{ border: this.state.borderStyles.serialNumber }}
                      onClick={() => this.setBorder("serialNumber")}
                      onChange={(e) =>
                        this.setState({ serialNumber: e.target.value })
                      }
                    />
                  </div>
                  <div className="textFieldStyle width50100">
                    <h6 className="InputLabel Fonts SizeFont">Value</h6>
                    <Input
                      placeholder="Enter Value"
                      type="number"
                      style={{ border: this.state.borderStyles.value }}
                      value={this.state.value}
                      onClick={() => this.setBorder("value")}
                      onChange={(e) => this.setState({ value: e.target.value })}
                    />
                  </div>
                </div>
                {type &&
                  COLLATERAL_FIELDS[type]
                    .reduce((rows, field, index) => {
                      if (index % 2 === 0) {
                        rows.push([field]);
                      } else {
                        rows[rows.length - 1].push(field);
                      }
                      return rows;
                    }, [])
                    .map((row, rowIndex) => (
                      <div className="flexRowColumn" key={rowIndex}>
                        {row.map((field) => this.renderField(field))}
                      </div>
                    ))}
                <div
                  className="previewComponent"
                  style={{ paddingTop: "15px" }}
                >
                  <p className="Fonts">Upload Collateral Image</p>
                  {this.state.imagePreviewUrl ? (
                    <img className="imgPreview" src={this.state.imagePreviewUrl} alt="preview" />
                  ) : (
                    <div>
                    </div>
                  )}
                  <div>
                    <input
                      className="fileInput"
                      type="file"
                      accept="image/*"
                      onChange={this.handleImageChange}
                    /></div>
                </div>
              </form>
            </div>
          </Card>

          <div style={{ textAlign: "end" }}>
            <Button
              variant="contained"
              color="primary"
              className="savebutton btnSizeFont Fonts"
              onClick={this.handleSubmit}
            >
              {this.state.collateralId ? "Update Collateral" : "Add Collateral"}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default withNamespaces()(AddCollateral);
